import { render, staticRenderFns } from "./CardWithHeader.vue?vue&type=template&id=e2d17d5e&scoped=true&"
import script from "./CardWithHeader.vue?vue&type=script&lang=js&"
export * from "./CardWithHeader.vue?vue&type=script&lang=js&"
import style0 from "./CardWithHeader.vue?vue&type=style&index=0&id=e2d17d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d17d5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon})
